import { Box, Stack, Typography } from '@mui/material';
import { type GetApprovalFlowInvoicesListResponse } from '@weft/api-definition';
import { INVOICE_REVIEW_STATUSES } from '@weft/types';
import type { ItemOf } from '@weft/utils';
import { ColorDot } from 'apps/app/src/components/design/ColorDot';
import { Price } from 'apps/app/src/components/design/Price';
import { LINE_ITEM_SIZE } from './ApprovalFlowInvoicesList';

type ApprovalFlowInvoicesListItemProps = {
  invoice: ItemOf<GetApprovalFlowInvoicesListResponse>;
  isSelected: boolean;
  onClick: (invoiceId: string) => void;
};

export const ApprovalFlowInvoicesListItem: React.FC<ApprovalFlowInvoicesListItemProps> = ({ invoice, isSelected, onClick }) => {
  const isInvoiceApproved = invoice.reviewStatus === INVOICE_REVIEW_STATUSES.Approved;

  return (
    <Box
      className='group'
      bgcolor={isSelected ? theme => theme.palette.action.selected : undefined}
      onClick={() => onClick(invoice.invoiceId)}
      sx={{
        cursor: 'pointer',
        padding: '16px 12px 16px 12px',
        height: `${LINE_ITEM_SIZE}px`,
        '&:hover': {
          backgroundColor: theme => theme.palette.action.hover,
        },
      }}
    >
      <Stack
        gap={2}
        direction="column"
      >
        <Stack
          paddingLeft={0.5}
          direction="row"
          justifyContent="space-between"
        >
          <Typography
            variant='body2'
            className='truncate'
            color={theme => isInvoiceApproved ? theme.palette.text.secondary : theme.palette.text.primary}
          >
            {invoice.customerName}
          </Typography>
          <Price
            variant='body2'
            color={theme => invoice.revenueBreakdown.overage > 0 ? theme.palette.error.light : theme.palette.text.secondary}
            currency={invoice.currency}
          >
            {invoice.revenueBreakdown.total}
          </Price>
        </Stack>
        <Stack
          gap={isInvoiceApproved ? 0 : 1}
          alignItems="center"
          divider={isInvoiceApproved 
            ? ( 
              <ColorDot
                color="#768B99"
                sizeOverride='2px'
              />
            )
            : undefined}
          direction="row"
        >
        </Stack>
      </Stack>
    </Box>
  );
};